/**
 * Главный оркестратор модулей поиска словарей
 * Сохраняет публичный API для обратной совместимости
 * 
 * Модули загружаются через отдельные <script> теги в search.php в правильном порядке:
 * 1. search/state.js - состояние
 * 2. search/utils.js - утилиты
 * 3. search/language.js - языки и локализация
 * 4. search/search.js - логика поиска
 * 5. search/results.js - результаты
 * 6. search/lemmatization.js - лемматизация
 * 7. search/ui.js - UI компоненты
 * 8. search/modal.js - модалки
 * 9. search/events/ - обработчики событий (border-radius.js, text-selection.js, sticky.js, handlers.js, search-events.js)
 */

// Экспортируем публичный API для обратной совместимости
// Эти функции должны быть доступны глобально для использования в HTML (onclick, onsubmit и т.д.)
(function() {
  // Ждем загрузки всех модулей
  function initPublicAPI() {
    // performSearch - используется в onsubmit формы
    window.performSearch = function(event) {
      if (window.SEARCH) {
        return window.SEARCH.performSearch(event);
      }
      return false;
    };
    
    // Модалки - используются в onclick
    window.openSearchTypeModal = function() {
      if (window.SEARCH_MODAL) {
        window.SEARCH_MODAL.openSearchTypeModal();
      }
    };
    
    window.closeSearchTypeModal = function() {
      if (window.SEARCH_MODAL) {
        window.SEARCH_MODAL.closeSearchTypeModal();
      }
    };
    
    window.openDictModal = function(element) {
      if (window.SEARCH_MODAL) {
        window.SEARCH_MODAL.openDictModal(element);
      }
    };
    
    window.closeDictModal = function() {
      if (window.SEARCH_MODAL) {
        window.SEARCH_MODAL.closeDictModal();
      }
    };

    // Тема - переключение
    window.toggleTheme = function() {
      if (window.THEME) {
        window.THEME.toggle();
      }
    };

    // Принудительная инициализация скролла из хэша
    if (window.location.hash.indexOf('#term-') === 0) {
      if (window.SEARCH_UI && window.SEARCH_UI.expandTermFromHash) {
        window.SEARCH_UI.expandTermFromHash();
      }
    }
  }
  
  // Инициализируем API после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPublicAPI);
  } else {
    // DOM уже загружен, но модули могут еще загружаться
    // Используем небольшую задержку для гарантии загрузки модулей
    setTimeout(initPublicAPI, 10);
  }
})();

